<template>
  <section>
    <form method="post" @submit.prevent="onSend">
      <form-wrapper :validator="$v.form">
        <b-field horizontal :label="$t('attributes.name')">
          <b-input v-model="group_name" disabled expanded></b-input>
        </b-field>

        <b-field horizontal :label="$t('attributes.group_code')">
          <b-input v-model="group_code" disabled expanded></b-input>
        </b-field>

        <form-group horizontal name="picture" :label="$t('attributes.cover')">
          <template #label>
            {{ $t('attributes.cover') }}
            <b-tooltip type="is-dark" label="500x500/限定jpg檔，100KB內">
              <b-icon size="is-small" icon="help-circle-outline"></b-icon>
            </b-tooltip>
          </template>
          <b-field class="file">
            <a class="button is-primary" @click="onSelectImage">
              <b-icon icon="upload"></b-icon>
              <span>{{ $t('message.please_select_file') }}</span>
            </a>
            <p
              v-if="form.picture"
              class="tag is-warning"
              style="margin-left: 4px; height: 40px"
            >
              <a
                :href="productImageUrl(form.picture)"
                @click.prevent="onClickImage(form.picture)"
              >
                {{ form.picture }}
              </a>
            </p>
          </b-field>
        </form-group>

        <form-group horizontal name="status" :label="$t('attributes.display')">
          <b-select v-model="form.status" name="status">
            <option :value="true">{{ $t('attributes.yes') }}</option>
            <option :value="false">{{ $t('attributes.no') }}</option>
          </b-select>
        </form-group>

        <form-group horizontal name="name" :label="$t('attributes.name')">
          <b-input
            v-model="form.name"
            name="name"
            maxlength="10"
            :placeholder="$t('message.please_input') + $t('attributes.name')"
            expanded
          ></b-input>
        </form-group>

        <form-group
          horizontal
          name="remark"
          :label="$t('attributes.description')"
        >
          <b-input
            v-model="form.remark"
            name="remark"
            maxlength="20"
            :placeholder="
              $t('message.please_input') + $t('attributes.description')
            "
            expanded
          ></b-input>
        </form-group>

        <b-field horizontal grouped>
          <b-button
            disabled="disabled"
            :loading="sending"
            type="is-primary"
            native-type="submit"
            :style="{ width: '100%' }"
          >
            {{ $t('attributes.update_data') }}
          </b-button>
        </b-field>
      </form-wrapper>
    </form>

    <b-modal :active.sync="isImageModalActive">
      <p class="image">
        <img :src="selectedImageUrl" alt="" />
      </p>
    </b-modal>

    <b-loading :active.sync="sending" :is-full-page="false"></b-loading>
  </section>
</template>

<script>
import { maxLength, required, requiredIf } from 'vuelidate/lib/validators'
import { TRAVEL_GROUPS_API } from '@/utils/apis'
import notifyService from '@/services/notifyService'
import { OpenProjectFinder } from '@/utils/ckfinder'

export default {
  name: 'HoneyMoonRecommend',

  props: {
    travelGroup: {
      required: true,
      type: Object
    }
  },
  data() {
    return {
      sending: false,

      group_code: this.travelGroup.code,
      group_name: this.travelGroup.name,

      form: {
        status: false,
        picture: null,
        name: null,
        remark: null
      },

      isImageModalActive: false,
      selectedImageUrl: null
    }
  },
  validations: {
    form: {
      status: { required },
      picture: {
        requiredIf: requiredIf(function(model) {
          return model.status
        }),
        maxLength: maxLength(50)
      },
      name: {
        requiredIf: requiredIf(function(model) {
          return model.status
        }),
        maxLength: maxLength(500)
      },
      remark: {
        requiredIf: requiredIf(function(model) {
          return model.status
        }),
        maxLength: maxLength(5000)
      }
    }
  },
  watch: {
    travelGroup(group) {
      this.group_code = group.code
      this.group_name = group.name
      this.fetchHoneyMoon()
    },
    'form.show'() {
      this.$v.$reset()
    }
  },
  mounted() {
    this.fetchHoneyMoon()
  },
  methods: {
    async fetchHoneyMoon() {
      const api = `${TRAVEL_GROUPS_API}/${this.group_code}/honey-moon-recommend`

      try {
        this.sending = true
        const res = await this.axios.get(api)

        const data = res.data.data
        this.form = {
          status: data.status,
          sort: data.sort,
          picture: data.picture,
          name: data.name,
          remark: data.remark
        }
      } catch (e) {
        this.form = {
          status: false,
          sort: 1,
          picture: null,
          name: null,
          remark: null
        }

        notifyService.fetch_error('honey_moon', e)
      } finally {
        this.sending = false
      }
    },
    onClickImage(url) {
      this.isImageModalActive = true
      this.selectedImageUrl = this.projectImageUrl(url)
    },
    async onSelectImage() {
      try {
        this.form.picture = await OpenProjectFinder()
      } catch (e) {
        notifyService.error(e)
      }
    },
    async onSend() {
      this.$v.$touch()

      if (this.$v.$invalid) {
        return
      }

      const api = `${TRAVEL_GROUPS_API}/${this.group_code}/honey-moon-recommend`

      try {
        this.sending = true
        await this.axios.put(api, this.form)

        notifyService.success(`${this.$t('attributes.update_succeed')}`)
      } catch (e) {
        notifyService.update_error(e)
      } finally {
        this.sending = false
      }
    }
  }
}
</script>
